import { render, staticRenderFns } from "./dialog-beginnerTipsDia.vue?vue&type=template&id=13d6f102&scoped=true&"
import script from "./dialog-beginnerTipsDia.vue?vue&type=script&lang=js&"
export * from "./dialog-beginnerTipsDia.vue?vue&type=script&lang=js&"
import style0 from "./dialog-beginnerTipsDia.vue?vue&type=style&index=0&id=13d6f102&lang=scss&scoped=scoped&"
import style1 from "./dialog-beginnerTipsDia.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d6f102",
  null
  
)

export default component.exports